// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__1sSWM","btnRed":"styles_btnRed__lhe9z","tg_tender_list":"styles_tg_tender_list__2tE1W","pagination":"styles_pagination__3q7JR"};